import { render, staticRenderFns } from "./RoleSelecter.vue?vue&type=template&id=10d5a6fd"
import script from "./RoleSelecter.vue?vue&type=script&lang=js"
export * from "./RoleSelecter.vue?vue&type=script&lang=js"
import style0 from "./RoleSelecter.vue?vue&type=style&index=0&id=10d5a6fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports